import React from 'react';
import styles from '../command-palette.scss';

export const CommandPaletteDivider = () => {
  return <div className={styles.commandPaletteDivider} />;
};
